import { render, staticRenderFns } from "./purchase-list.vue?vue&type=template&id=7fcf5334&scoped=true&"
import script from "./purchase-list.vue?vue&type=script&lang=ts&"
export * from "./purchase-list.vue?vue&type=script&lang=ts&"
import style0 from "./purchase-list.vue?vue&type=style&index=0&id=7fcf5334&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcf5334",
  null
  
)

export default component.exports